import { render, staticRenderFns } from "./RegisterInfoForm.vue?vue&type=template&id=79b650a6&scoped=true"
import script from "./RegisterInfoForm.vue?vue&type=script&lang=js"
export * from "./RegisterInfoForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfoForm.vue?vue&type=style&index=0&id=79b650a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b650a6",
  null
  
)

export default component.exports